import { render, staticRenderFns } from "./demographic-charts.vue?vue&type=template&id=d116cf5e&scoped=true&"
import script from "./demographic-charts.vue?vue&type=script&lang=ts&"
export * from "./demographic-charts.vue?vue&type=script&lang=ts&"
import style0 from "./demographic-charts.vue?vue&type=style&index=0&id=d116cf5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d116cf5e",
  null
  
)

export default component.exports